import { useTranslation } from 'react-i18next'

import { Avatar } from '../../../../../Avatar'
import { isEmailRecipientLocked } from '../../../../../Email'
import {
  getTagActionSize,
  Tag,
  TAG_APPEARANCE,
  TAG_HEIGHT,
} from '../../../../../Tag'
import {
  getAppointmentFormParticipantTagName,
  getIsAppointmentFormParticipantProfile,
  getIsAppointmentFormParticipantWithoutEmail,
} from '../../../AppointmentFormModal.utils.participants'

import * as styles from './AppointmentFormModalParticipantTag.module.css'

function AppointmentFormModalParticipantTag({
  disabled,
  isOpen,
  item,
  qaName,
  onDeleteOption,
}) {
  const { t } = useTranslation()

  const height = isOpen ? TAG_HEIGHT.height24 : TAG_HEIGHT.height32

  const tagName = getAppointmentFormParticipantTagName(item)

  const isWithoutEmail = getIsAppointmentFormParticipantWithoutEmail(item)

  const noEmailText = t('Appointment.FormParticipantNoEmailKey')

  function handleDeleteOption() {
    onDeleteOption(item)
  }

  return (
    <Tag
      appearance={isOpen ? TAG_APPEARANCE.filled : TAG_APPEARANCE.outlined}
      beforeContent={
        !isOpen && getIsAppointmentFormParticipantProfile(item) ? (
          <Avatar {...item.avatar} size={getTagActionSize(height)} />
        ) : null
      }
      height={height}
      isDisabled={disabled}
      qaName={qaName}
      text={
        isWithoutEmail ? (
          <>
            {tagName}
            <span className={styles.noEmail}>{noEmailText}</span>
          </>
        ) : (
          tagName
        )
      }
      tooltip={isWithoutEmail ? `${tagName} ${noEmailText}` : tagName}
      onRemove={
        isOpen && !isEmailRecipientLocked(item) ? handleDeleteOption : undefined
      }
    />
  )
}

export default AppointmentFormModalParticipantTag
